import axios from 'axios';
import type { AxiosRequestConfig } from 'axios';
import { getCookie, setCookie } from '@/utils/cookie';
import { getEnv, getPFB } from '@/utils/getEnv';

export const WMS_TEST_USER_INFO_HEADER = 'Wms-Test-User-Info';
const DEV_AUTH_ENABLED = false;

export const getDevAuthWhsId = () => {
  return getCookie('setting_whs_v2') || getCookie('setting_whs') || 'SGL';
};

export const getDevAuthUserEmail = () => {
  return getCookie('ssc_user_email') || 'autotest@shopee.com';
};

export const getDevAuthUserId = () => {
  return getCookie('wms_user_id') || '2015';
};

export const WMS_TEST_USER_INFO = () =>
  `USER_EMAIL:${getDevAuthUserEmail()};WHS_ID:${getDevAuthWhsId()};USER_ID:${getDevAuthUserId()}`;

export const isPFBEnv = () => {
  return getPFB() === 'PFB';
};

export const isTestHost = () => {
  return (
    typeof location !== 'undefined' && /(^|\.)test\./.test(location.hostname)
  );
};

export const isLocalDevHost = () => {
  return (
    typeof location !== 'undefined' &&
    ['localhost', '127.0.0.1'].includes(location.hostname)
  );
};

export const isMockLoginInfoEnabled = () => {
  return (
    DEV_AUTH_ENABLED && (isPFBEnv() || getEnv() === 'test' || isTestHost())
  );
};

export const isDevAuthEnabled = () => {
  return (
    DEV_AUTH_ENABLED &&
    (isPFBEnv() ||
      isTestHost() ||
      ['dev', 'development', 'test'].includes(getEnv()))
  );
};

export const isDevAuthHeaderEnabled = () => {
  return isDevAuthEnabled() && isLocalDevHost();
};

export const ensureDevAuthWhsCookie = () => {
  if (!isDevAuthEnabled() || typeof document === 'undefined') {
    return;
  }

  if (!getCookie('setting_whs_v2')) {
    setCookie('setting_whs_v2', 'SGL', 7);
  }
};

export const addDevAuthHeader = (config: AxiosRequestConfig | any) => {
  if (!isDevAuthHeaderEnabled()) {
    return config;
  }

  config.headers = config.headers || {};
  config.headers[WMS_TEST_USER_INFO_HEADER] = WMS_TEST_USER_INFO();
  return config;
};

if (isDevAuthHeaderEnabled()) {
  ensureDevAuthWhsCookie();
  axios.defaults.headers.common[WMS_TEST_USER_INFO_HEADER] =
    WMS_TEST_USER_INFO();
}
